import React from "react";
import { motion } from "framer-motion";
import { FEATURES, ASSETS } from "../../data/site";
import { PhoneFrame } from "./PhoneFrame";
import { Reveal } from "./Reveal";

export const Features = () => (
  <section id="features" className="relative py-24 md:py-32" data-testid="features-section">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="max-w-2xl">
        <Reveal>
          <p className="text-sm font-semibold uppercase tracking-[0.15em] text-[#8AA583]">
            Features
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="font-heading mt-5 text-4xl font-semibold leading-[1.15] tracking-tight text-[#111E16] md:text-5xl">
            Everything you need to feel safe and connected.
          </h2>
        </Reveal>
      </div>

      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {FEATURES.map((f, i) => {
          const Icon = f.icon;
          return (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              whileHover={{ y: -6 }}
              className="group rounded-3xl border border-[#2F5E43]/5 bg-white p-8 shadow-[0_8px_30px_rgba(0,0,0,0.04)] transition-shadow duration-300 hover:shadow-[0_18px_40px_rgba(47,94,67,0.12)]"
              data-testid={`feature-card-${i}`}
            >
              <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#E4EDE6] text-[#2F5E43] transition-colors group-hover:bg-[#2F5E43] group-hover:text-white">
                <Icon className="h-6 w-6" />
              </span>
              <h3 className="font-heading mt-5 text-xl font-semibold text-[#111E16]">
                {f.title}
              </h3>
              <p className="mt-2.5 leading-relaxed text-[#4A5F52]">{f.desc}</p>
            </motion.div>
          );
        })}
      </div>

      <Reveal>
        <div className="mt-16 grid items-center gap-10 rounded-[2.5rem] border border-[#2F5E43]/10 bg-white p-8 shadow-[0_8px_30px_rgba(0,0,0,0.04)] md:grid-cols-2 md:p-14">
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.15em] text-[#8AA583]">
              Safe Places
            </p>
            <h3 className="font-heading mt-4 text-3xl font-semibold leading-tight tracking-tight text-[#111E16] md:text-4xl">
              Verified help, right where you are.
            </h3>
            <p className="mt-4 text-lg leading-relaxed text-[#4A5F52]">
              Discover trusted safe spaces nearby, like shelters, hospitals, pharmacies and
              support lines, with community insights so you always know where to turn.
            </p>
          </div>
          <div className="flex justify-center">
            <PhoneFrame
              src={ASSETS.safePlaces}
              alt="SisterSafe Safe Places nearby map"
              testId="safe-places-showcase"
              className="w-[62%] max-w-[260px]"
            />
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
